const NetWorkErrorHandler = require('../handlers/networkError.handler')

const errorHandlerMiddleware = async ({ form, query, Handler }) => {
  try {
    return await query()
  } catch (err) {
    if (err.networkError) {
      const networkHandler = new NetWorkErrorHandler(err, form)
      return networkHandler.handle()
    } else {
      const handler = new Handler(err, form)
      return handler.handle()
    }

  }
}

module.exports = errorHandlerMiddleware;